// extracted by mini-css-extract-plugin
export default {"CustomButton":"ButtonStyle_CustomButton__ikxnJ","CustomButton_Text":"ButtonStyle_CustomButton_Text__Opuij"};